export const SwapIcon = ({
  className = "",
  fillColor = "#333333",
  width = 24,
  height = 24,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 9.97738C2 9.4251 2.44772 8.97738 3 8.97738H21C21.5523 8.97738 22 9.4251 22 9.97738C22 10.5297 21.5523 10.9774 21 10.9774H3C2.44772 10.9774 2 10.5297 2 9.97738Z"
        fill={fillColor}
      />
      <path
        d="M15.3196 4.29289C15.7101 3.90237 16.3432 3.90237 16.7338 4.29289L21.707 9.26608C22.0975 9.65661 22.0975 10.2898 21.707 10.6803C21.3164 11.0708 20.6833 11.0708 20.2928 10.6803L15.3196 5.70711C14.929 5.31658 14.929 4.68342 15.3196 4.29289Z"
        fill={fillColor}
      />
      <path
        d="M22 14.0226C22 14.5749 21.5523 15.0226 21 15.0226L3 15.0226C2.44772 15.0226 2 14.5749 2 14.0226C2 13.4703 2.44772 13.0226 3 13.0226L21 13.0226C21.5523 13.0226 22 13.4703 22 14.0226Z"
        fill={fillColor}
      />
      <path
        d="M8.68044 19.7071C8.28992 20.0976 7.65675 20.0976 7.26623 19.7071L2.29304 14.7339C1.90251 14.3434 1.90251 13.7102 2.29304 13.3197C2.68356 12.9292 3.31673 12.9292 3.70725 13.3197L8.68044 18.2929C9.07097 18.6834 9.07097 19.3166 8.68044 19.7071Z"
        fill={fillColor}
      />
    </svg>
  );
};
export const InfoCirclesIcon = ({
  className = "",
  fillColor = "#333333",
  width = 24,
  height = 24,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM13 15.5C13 15.7652 12.8946 16.0196 12.7071 16.2071C12.5196 16.3946 12.2652 16.5 12 16.5C11.7348 16.5 11.4804 16.3946 11.2929 16.2071C11.1054 16.0196 11 15.7652 11 15.5V12.5C11 12.2348 11.1054 11.9804 11.2929 11.7929C11.4804 11.6054 11.7348 11.5 12 11.5C12.2652 11.5 12.5196 11.6054 12.7071 11.7929C12.8946 11.9804 13 12.2348 13 12.5V15.5ZM12 10C11.7528 10 11.5111 9.92669 11.3055 9.78934C11.1 9.65199 10.9398 9.45676 10.8452 9.22835C10.7505 8.99995 10.7258 8.74861 10.774 8.50614C10.8223 8.26366 10.9413 8.04093 11.1161 7.86612C11.2909 7.6913 11.5137 7.57225 11.7561 7.52402C11.9986 7.47579 12.25 7.50054 12.4784 7.59515C12.7068 7.68976 12.902 7.84998 13.0393 8.05554C13.1767 8.2611 13.25 8.50277 13.25 8.75C13.25 9.08152 13.1183 9.39946 12.8839 9.63388C12.6495 9.8683 12.3315 10 12 10Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const CheckCircleIconV2 = ({
  className = "",
  fillColor = "#333333",
  width = 24,
  height = 24,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.72 8.79L10.43 13.09L8.78 11.44C8.69036 11.3353 8.58004 11.2503 8.45597 11.1903C8.33191 11.1303 8.19678 11.0965 8.05906 11.0912C7.92134 11.0859 7.78401 11.1091 7.65568 11.1594C7.52736 11.2096 7.41081 11.2859 7.31335 11.3833C7.2159 11.4808 7.13964 11.5974 7.08937 11.7257C7.03909 11.854 7.01589 11.9913 7.02121 12.1291C7.02653 12.2668 7.06026 12.4019 7.12028 12.526C7.1803 12.65 7.26532 12.7604 7.37 12.85L9.72 15.21C9.81344 15.3027 9.92426 15.376 10.0461 15.4258C10.1679 15.4755 10.2984 15.5008 10.43 15.5C10.6923 15.4989 10.9437 15.3947 11.13 15.21L16.13 10.21C16.2237 10.117 16.2981 10.0064 16.3489 9.88458C16.3997 9.76272 16.4258 9.63201 16.4258 9.5C16.4258 9.36799 16.3997 9.23728 16.3489 9.11542C16.2981 8.99356 16.2237 8.88296 16.13 8.79C15.9426 8.60375 15.6892 8.49921 15.425 8.49921C15.1608 8.49921 14.9074 8.60375 14.72 8.79ZM12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const FilterIcon = ({
  className = "",
  fillColor = "#333333",
  width = 24,
  height = 24,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 2H5C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V6.17C1.99986 6.58294 2.08497 6.99147 2.25 7.37V7.43C2.39128 7.75097 2.59139 8.04266 2.84 8.29L9 14.41V21C8.99966 21.1699 9.04264 21.3372 9.12487 21.4859C9.20711 21.6346 9.32589 21.7599 9.47 21.85C9.62914 21.9486 9.81277 22.0006 10 22C10.1565 21.9991 10.3107 21.9614 10.45 21.89L14.45 19.89C14.6149 19.8069 14.7536 19.6798 14.8507 19.5227C14.9478 19.3656 14.9994 19.1847 15 19V14.41L21.12 8.29C21.3686 8.04266 21.5687 7.75097 21.71 7.43V7.37C21.8888 6.99443 21.9876 6.58578 22 6.17V5C22 4.20435 21.6839 3.44129 21.1213 2.87868C20.5587 2.31607 19.7956 2 19 2ZM13.29 13.29C13.1973 13.3834 13.124 13.4943 13.0742 13.6161C13.0245 13.7379 12.9992 13.8684 13 14V18.38L11 19.38V14C11.0008 13.8684 10.9755 13.7379 10.9258 13.6161C10.876 13.4943 10.8027 13.3834 10.71 13.29L5.41 8H18.59L13.29 13.29ZM20 6H4V5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H19C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8946 4.48043 20 4.73478 20 5V6Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const EmptyIcon = ({
  className = "",
  fillColor = "#333333",
  width = 24,
  height = 24,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6 10.9C13.7 11 13.8 11 14 11H21C21.6 11 22 10.6 22 10C22 9.8 22 9.7 21.9 9.6L18.4 2.6C18.1 2.1 17.5 1.9 17 2.2C16.9 2.3 16.7 2.4 16.6 2.6L13.1 9.6C12.9 10 13.1 10.6 13.6 10.9ZM17.5 5.2L19.4 9H15.6L17.5 5.2ZM6.5 2C4 2 2 4 2 6.5C2 9 4 11 6.5 11C9 11 11 9 11 6.5C11 4 9 2 6.5 2ZM6.5 9C5.1 9 4 7.9 4 6.5C4 5.1 5.1 4 6.5 4C7.9 4 9 5.1 9 6.5C9 7.9 7.9 9 6.5 9ZM10.7 13.3C10.3 12.9 9.7 12.9 9.3 13.3L6.5 16.1L3.7 13.3C3.3 12.9 2.7 12.9 2.3 13.3C1.9 13.7 1.9 14.3 2.3 14.7L5.1 17.5L2.3 20.3C1.9 20.7 1.9 21.3 2.3 21.7C2.7 22.1 3.3 22.1 3.7 21.7L6.5 18.9L9.3 21.7C9.7 22.1 10.3 22.1 10.7 21.7C11.1 21.3 11.1 20.7 10.7 20.3L7.9 17.5L10.7 14.7C11.1 14.3 11.1 13.7 10.7 13.3ZM21 13H14C13.4 13 13 13.4 13 14V21C13 21.6 13.4 22 14 22H21C21.6 22 22 21.6 22 21V14C22 13.4 21.6 13 21 13ZM20 20H15V15H20V20Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const StarIcon = ({
  className = "",
  fillColor = "#333333",
  width = 24,
  height = 24,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 9.67002C21.9368 9.48711 21.822 9.32645 21.6693 9.20753C21.5167 9.0886 21.3328 9.01652 21.14 9.00002L15.45 8.17002L12.9 3.00002C12.8181 2.83095 12.6902 2.68837 12.5311 2.5886C12.3719 2.48883 12.1878 2.43591 12 2.43591C11.8121 2.43591 11.6281 2.48883 11.4689 2.5886C11.3097 2.68837 11.1819 2.83095 11.1 3.00002L8.54998 8.16002L2.85998 9.00002C2.6749 9.02633 2.5009 9.10399 2.35773 9.22418C2.21455 9.34438 2.10794 9.5023 2.04998 9.68002C1.99692 9.8537 1.99216 10.0385 2.03621 10.2147C2.08025 10.3909 2.17144 10.5517 2.29998 10.68L6.42998 14.68L5.42998 20.36C5.39428 20.5475 5.41297 20.7413 5.48385 20.9185C5.55473 21.0957 5.67483 21.2489 5.82998 21.36C5.98119 21.4681 6.15955 21.5319 6.34503 21.5443C6.5305 21.5567 6.71575 21.5171 6.87998 21.43L12 18.76L17.1 21.44C17.2403 21.5192 17.3988 21.5606 17.56 21.56C17.7718 21.5608 17.9784 21.4942 18.15 21.37C18.3051 21.2589 18.4252 21.1057 18.4961 20.9285C18.567 20.7513 18.5857 20.5575 18.55 20.37L17.55 14.69L21.68 10.69C21.8244 10.5677 21.9311 10.4069 21.9877 10.2264C22.0444 10.0458 22.0486 9.8529 22 9.67002ZM15.85 13.67C15.7327 13.7835 15.645 13.9239 15.5944 14.079C15.5439 14.2341 15.532 14.3993 15.56 14.56L16.28 18.75L12.52 16.75C12.3753 16.673 12.2139 16.6327 12.05 16.6327C11.8861 16.6327 11.7247 16.673 11.58 16.75L7.81998 18.75L8.53998 14.56C8.56791 14.3993 8.55609 14.2341 8.50554 14.079C8.45499 13.9239 8.36725 13.7835 8.24998 13.67L5.24998 10.67L9.45998 10.06C9.62198 10.0375 9.77598 9.97556 9.90848 9.87967C10.041 9.78379 10.1479 9.65686 10.22 9.51002L12 5.70002L13.88 9.52002C13.952 9.66686 14.059 9.79379 14.1915 9.88968C14.324 9.98556 14.478 10.0475 14.64 10.07L18.85 10.68L15.85 13.67Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const StarFillIcon = ({
  className = "",
  fillColor = "#333333",
  width = 24,
  height = 24,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9228 2.2245C13.3341 2.43565 13.667 2.78194 13.8699 3.20977L15.8304 7.34209L20.2142 8.00474C21.354 8.17702 22.1437 9.27786 21.9781 10.4635C21.9121 10.9357 21.6984 11.372 21.37 11.705L18.1978 14.9216L18.9467 19.4635C19.1414 20.6443 18.379 21.7658 17.2438 21.9683C16.7918 22.049 16.3268 21.9724 15.9208 21.7504L11.9999 19.606L8.0789 21.7504C7.05945 22.3079 5.79855 21.9002 5.2626 20.8397C5.04918 20.4174 4.97553 19.9337 5.05306 19.4635L5.8019 14.9216L2.62977 11.705C1.80502 10.8687 1.78815 9.49527 2.59208 8.63732C2.91221 8.29568 3.33167 8.07334 3.78554 8.00474L8.16931 7.34209L10.1298 3.20977C10.6395 2.13538 11.89 1.69426 12.9228 2.2245Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const EditAltIcon = ({
  className = "",
  fillColor = "#333333",
  width = 20,
  height = 20,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 17.9999H9.24C9.37161 18.0007 9.50207 17.9755 9.62391 17.9257C9.74574 17.8759 9.85656 17.8026 9.95 17.7099L16.87 10.7799L19.71 7.99994C19.8037 7.90698 19.8781 7.79637 19.9289 7.67452C19.9797 7.55266 20.0058 7.42195 20.0058 7.28994C20.0058 7.15793 19.9797 7.02722 19.9289 6.90536C19.8781 6.7835 19.8037 6.6729 19.71 6.57994L15.47 2.28994C15.377 2.19621 15.2664 2.12182 15.1446 2.07105C15.0227 2.02028 14.892 1.99414 14.76 1.99414C14.628 1.99414 14.4973 2.02028 14.3754 2.07105C14.2536 2.12182 14.143 2.19621 14.05 2.28994L11.23 5.11994L4.29 12.0499C4.19732 12.1434 4.12399 12.2542 4.07423 12.376C4.02446 12.4979 3.99924 12.6283 4 12.7599V16.9999C4 17.2652 4.10536 17.5195 4.29289 17.707C4.48043 17.8946 4.73478 17.9999 5 17.9999ZM14.76 4.40994L17.59 7.23994L16.17 8.65994L13.34 5.82994L14.76 4.40994ZM6 13.1699L11.93 7.23994L14.76 10.0699L8.83 15.9999H6V13.1699ZM21 19.9999H3C2.73478 19.9999 2.48043 20.1053 2.29289 20.2928C2.10536 20.4804 2 20.7347 2 20.9999C2 21.2652 2.10536 21.5195 2.29289 21.707C2.48043 21.8946 2.73478 21.9999 3 21.9999H21C21.2652 21.9999 21.5196 21.8946 21.7071 21.707C21.8946 21.5195 22 21.2652 22 20.9999C22 20.7347 21.8946 20.4804 21.7071 20.2928C21.5196 20.1053 21.2652 19.9999 21 19.9999Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const CoppyAltIcon = ({
  className = "",
  fillColor = "#333333",
  width = 20,
  height = 20,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 20H8C7.20435 20 6.44129 19.6839 5.87868 19.1213C5.31607 18.5587 5 17.7956 5 17V7C5 6.73478 4.89464 6.48043 4.70711 6.29289C4.51957 6.10536 4.26522 6 4 6C3.73478 6 3.48043 6.10536 3.29289 6.29289C3.10536 6.48043 3 6.73478 3 7V17C3 18.3261 3.52678 19.5979 4.46447 20.5355C5.40215 21.4732 6.67392 22 8 22H16C16.2652 22 16.5196 21.8946 16.7071 21.7071C16.8946 21.5196 17 21.2652 17 21C17 20.7348 16.8946 20.4804 16.7071 20.2929C16.5196 20.1054 16.2652 20 16 20ZM21 8.94C20.9896 8.84813 20.9695 8.75763 20.94 8.67V8.58C20.8919 8.47718 20.8278 8.38267 20.75 8.3L14.75 2.3C14.6673 2.22222 14.5728 2.15808 14.47 2.11H14.38L14.06 2H10C9.20435 2 8.44129 2.31607 7.87868 2.87868C7.31607 3.44129 7 4.20435 7 5V15C7 15.7956 7.31607 16.5587 7.87868 17.1213C8.44129 17.6839 9.20435 18 10 18H18C18.7956 18 19.5587 17.6839 20.1213 17.1213C20.6839 16.5587 21 15.7956 21 15V9C21 9 21 9 21 8.94ZM15 5.41L17.59 8H16C15.7348 8 15.4804 7.89464 15.2929 7.70711C15.1054 7.51957 15 7.26522 15 7V5.41ZM19 15C19 15.2652 18.8946 15.5196 18.7071 15.7071C18.5196 15.8946 18.2652 16 18 16H10C9.73478 16 9.48043 15.8946 9.29289 15.7071C9.10536 15.5196 9 15.2652 9 15V5C9 4.73478 9.10536 4.48043 9.29289 4.29289C9.48043 4.10536 9.73478 4 10 4H13V7C13 7.79565 13.3161 8.55871 13.8787 9.12132C14.4413 9.68393 15.2044 10 16 10H19V15Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ShareIcon = ({
  className = "",
  fillColor = "#FA8C16",
  width = 20,
  height = 20,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.707 11.293L13.707 3.29304C13.5672 3.15318 13.389 3.05794 13.195 3.01935C13.0011 2.98075 12.8 3.00055 12.6173 3.07622C12.4346 3.1519 12.2784 3.28006 12.1685 3.4445C12.0586 3.60894 12 3.80227 12 4.00004V7.54496C9.2683 7.7978 6.72926 9.0609 4.87973 11.0871C3.0302 13.1132 2.00331 15.7567 2 18.5V20C1.99998 20.2077 2.06463 20.4102 2.18495 20.5795C2.30528 20.7488 2.47532 20.8764 2.67147 20.9446C2.86762 21.0128 3.08014 21.0183 3.27954 20.9602C3.47893 20.9022 3.65531 20.7835 3.78418 20.6206C4.76383 19.4556 5.96583 18.4974 7.31997 17.8022C8.6741 17.1069 10.1532 16.6885 11.6709 16.5713C11.7207 16.565 11.8457 16.5552 12 16.5454V20C12 20.1978 12.0586 20.3911 12.1685 20.5556C12.2784 20.72 12.4346 20.8482 12.6173 20.9238C12.8 20.9995 13.0011 21.0193 13.195 20.9807C13.389 20.9421 13.5672 20.8469 13.707 20.707L21.707 12.707C21.7999 12.6142 21.8735 12.504 21.9238 12.3827C21.9741 12.2614 21.9999 12.1313 21.9999 12C21.9999 11.8687 21.9741 11.7387 21.9238 11.6174C21.8735 11.4961 21.7999 11.3859 21.707 11.293ZM14 17.586V15.5C14 15.3687 13.9742 15.2387 13.9239 15.1173C13.8737 14.996 13.8 14.8857 13.7072 14.7929C13.6143 14.7 13.5041 14.6263 13.3827 14.5761C13.2614 14.5258 13.1313 14.5 13 14.5C12.7451 14.5 11.7041 14.5494 11.4385 14.585C8.74307 14.8333 6.17736 15.8573 4.05176 17.5332C4.29289 15.3276 5.33918 13.2884 6.99026 11.8061C8.64135 10.3239 10.7812 9.50275 13 9.50004C13.1313 9.50007 13.2614 9.47423 13.3827 9.42399C13.5041 9.37374 13.6143 9.30008 13.7072 9.20722C13.8 9.11435 13.8737 9.0041 13.9239 8.88276C13.9742 8.76142 14 8.63137 14 8.50004V6.4141L19.5859 12L14 17.586Z"
        fill="#333333"
      />
    </svg>
  );
};

export const LinkAltIcon = ({
  className = "",
  fillColor = "#333333",
  width = 24,
  height = 24,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.11 15.3901L8.23002 19.2701C7.76026 19.7235 7.13288 19.9768 6.48002 19.9768C5.82716 19.9768 5.19978 19.7235 4.73002 19.2701C4.49962 19.0406 4.31681 18.7679 4.19207 18.4676C4.06733 18.1673 4.00312 17.8453 4.00312 17.5201C4.00312 17.1949 4.06733 16.8729 4.19207 16.5726C4.31681 16.2723 4.49962 15.9996 4.73002 15.7701L8.61002 11.8901C8.79832 11.7018 8.90411 11.4464 8.90411 11.1801C8.90411 10.9138 8.79832 10.6584 8.61002 10.4701C8.42172 10.2818 8.16632 10.176 7.90002 10.176C7.63372 10.176 7.37832 10.2818 7.19002 10.4701L3.31002 14.3601C2.52838 15.2109 2.10564 16.3308 2.13009 17.4858C2.15455 18.6409 2.6243 19.7419 3.44125 20.5589C4.2582 21.3758 5.35918 21.8456 6.51427 21.87C7.66935 21.8945 8.78923 21.4717 9.64002 20.6901L13.53 16.8101C13.7183 16.6218 13.8241 16.3664 13.8241 16.1001C13.8241 15.8338 13.7183 15.5784 13.53 15.3901C13.3417 15.2018 13.0863 15.096 12.82 15.096C12.5537 15.096 12.2983 15.2018 12.11 15.3901ZM20.69 3.31009C19.8488 2.4741 18.711 2.00488 17.525 2.00488C16.339 2.00488 15.2012 2.4741 14.36 3.31009L10.47 7.19009C10.3768 7.28333 10.3028 7.39402 10.2524 7.51585C10.2019 7.63767 10.1759 7.76824 10.1759 7.90009C10.1759 8.03195 10.2019 8.16252 10.2524 8.28434C10.3028 8.40617 10.3768 8.51686 10.47 8.61009C10.5633 8.70333 10.6739 8.77729 10.7958 8.82775C10.9176 8.87821 11.0482 8.90419 11.18 8.90419C11.3119 8.90419 11.4424 8.87821 11.5643 8.82775C11.6861 8.77729 11.7968 8.70333 11.89 8.61009L15.77 4.73009C16.2398 4.27672 16.8672 4.02335 17.52 4.02335C18.1729 4.02335 18.8003 4.27672 19.27 4.73009C19.5004 4.95958 19.6832 5.2323 19.808 5.53261C19.9327 5.83292 19.9969 6.15491 19.9969 6.48009C19.9969 6.80528 19.9327 7.12727 19.808 7.42758C19.6832 7.72789 19.5004 8.00061 19.27 8.23009L15.39 12.1101C15.2963 12.2031 15.2219 12.3137 15.1711 12.4355C15.1204 12.5574 15.0942 12.6881 15.0942 12.8201C15.0942 12.9521 15.1204 13.0828 15.1711 13.2047C15.2219 13.3265 15.2963 13.4371 15.39 13.5301C15.483 13.6238 15.5936 13.6982 15.7154 13.749C15.8373 13.7998 15.968 13.8259 16.1 13.8259C16.232 13.8259 16.3627 13.7998 16.4846 13.749C16.6065 13.6982 16.7171 13.6238 16.81 13.5301L20.69 9.64009C21.526 8.79887 21.9952 7.66107 21.9952 6.47509C21.9952 5.28912 21.526 4.15131 20.69 3.31009ZM8.83002 15.1701C8.92346 15.2628 9.03428 15.3361 9.15611 15.3859C9.27795 15.4356 9.40841 15.4609 9.54002 15.4601C9.67163 15.4609 9.80209 15.4356 9.92393 15.3859C10.0458 15.3361 10.1566 15.2628 10.25 15.1701L15.17 10.2501C15.3583 10.0618 15.4641 9.8064 15.4641 9.54009C15.4641 9.27379 15.3583 9.0184 15.17 8.83009C14.9817 8.64179 14.7263 8.536 14.46 8.536C14.1937 8.536 13.9383 8.64179 13.75 8.83009L8.83002 13.7501C8.73629 13.8431 8.6619 13.9537 8.61113 14.0755C8.56036 14.1974 8.53422 14.3281 8.53422 14.4601C8.53422 14.5921 8.56036 14.7228 8.61113 14.8447C8.6619 14.9665 8.73629 15.0771 8.83002 15.1701Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ExportIcon = ({
  className = "",
  fillColor = "#333333",
  width = 24,
  height = 24,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9 22.75H15C20.43 22.75 22.75 20.43 22.75 15V13C22.75 12.59 22.41 12.25 22 12.25C21.59 12.25 21.25 12.59 21.25 13V15C21.25 19.61 19.61 21.25 15 21.25H9C4.39 21.25 2.75 19.61 2.75 15V9C2.75 4.39 4.39 2.75 9 2.75H11C11.41 2.75 11.75 2.41 11.75 2C11.75 1.59 11.41 1.25 11 1.25H9C3.57 1.25 1.25 3.57 1.25 9V15C1.25 20.43 3.57 22.75 9 22.75ZM22 7.55C21.59 7.55 21.25 7.21 21.25 6.8V3.81022L13.5299 11.5302C13.3799 11.6802 13.1899 11.7502 12.9999 11.7502C12.8099 11.7502 12.6199 11.6802 12.4699 11.5302C12.1799 11.2402 12.1799 10.7602 12.4699 10.4702L20.1902 2.75H17.2C16.79 2.75 16.45 2.41 16.45 2C16.45 1.59 16.79 1.25 17.2 1.25H22C22.41 1.25 22.75 1.59 22.75 2V6.8C22.75 7.21 22.41 7.55 22 7.55Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ManagementIcon = ({
  width = 24,
  height = 24,
  className = "",
  fillColor = "#999999",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.5 17C7.4 17 6.5 17.9 6.5 19C6.5 20.1 7.4 21 8.5 21C9.6 21 10.5 20.1 10.5 19C10.5 17.9 9.6 17 8.5 17ZM15.5 7C16.6 7 17.5 6.1 17.5 5C17.5 3.9 16.6 3 15.5 3C14.4 3 13.5 3.9 13.5 5C13.5 6.1 14.4 7 15.5 7ZM8.5 10C7.4 10 6.5 10.9 6.5 12C6.5 13.1 7.4 14 8.5 14C9.6 14 10.5 13.1 10.5 12C10.5 10.9 9.6 10 8.5 10ZM15.5 10C14.4 10 13.5 10.9 13.5 12C13.5 13.1 14.4 14 15.5 14C16.6 14 17.5 13.1 17.5 12C17.5 10.9 16.6 10 15.5 10ZM15.5 17C14.4 17 13.5 17.9 13.5 19C13.5 20.1 14.4 21 15.5 21C16.6 21 17.5 20.1 17.5 19C17.5 17.9 16.6 17 15.5 17ZM8.5 3C7.4 3 6.5 3.9 6.5 5C6.5 6.1 7.4 7 8.5 7C9.6 7 10.5 6.1 10.5 5C10.5 3.9 9.6 3 8.5 3Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const AngelRightIcon = ({
  width = 24,
  height = 24,
  className = "",
  fillColor = "#999999",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.83 11.2902L10.59 7.05019C10.497 6.95646 10.3864 6.88207 10.2646 6.8313C10.1427 6.78053 10.012 6.75439 9.88 6.75439C9.74799 6.75439 9.61729 6.78053 9.49543 6.8313C9.37357 6.88207 9.26297 6.95646 9.17 7.05019C8.98375 7.23756 8.87921 7.49101 8.87921 7.75519C8.87921 8.01938 8.98375 8.27283 9.17 8.46019L12.71 12.0002L9.17 15.5402C8.98375 15.7276 8.87921 15.981 8.87921 16.2452C8.87921 16.5094 8.98375 16.7628 9.17 16.9502C9.26344 17.0429 9.37426 17.1162 9.4961 17.166C9.61794 17.2157 9.7484 17.241 9.88 17.2402C10.0116 17.241 10.1421 17.2157 10.2639 17.166C10.3857 17.1162 10.4966 17.0429 10.59 16.9502L14.83 12.7102C14.9237 12.6172 14.9981 12.5066 15.0489 12.3848C15.0997 12.2629 15.1258 12.1322 15.1258 12.0002C15.1258 11.8682 15.0997 11.7375 15.0489 11.6156C14.9981 11.4938 14.9237 11.3832 14.83 11.2902Z"
        fill={fillColor}
      />
    </svg>
  );
};
